module.exports = __webpack_public_path__ + "img/unicorn-display.41ad7ae4.png";